<template>
    <div class="card">
        <div class="card-header">
            {{ $t('results.title') }}
            <button @click="showNewElementModal"  id="createNewEntryButton" data-placement="left" class="float-right btn btn-sm btn-success">
                {{ $t('update.button') }}
            </button>
        </div>
        <div class="card-body">
            <div v-if="loading" class="text-center">
                <loading-indicator></loading-indicator>
            </div>

            <table v-else class="table" id="resultTable">
                <thead>
                    <tr>
                        <th class="filterable" @click="sort('to_code')">{{ $t('filter.touroperator') }} <font-awesome-icon :icon="icons.to_code" v-if="allowedSortings.to_code"></font-awesome-icon></th>
                        <th>{{ $t('update.name') }}</th>
                        <th class="filterable" @click="sort('valid_from')">{{ $t('filter.validFrom') }} <font-awesome-icon :icon="icons.valid_from" v-if="allowedSortings.valid_from"></font-awesome-icon></th>
                        <th class="filterable" @click="sort('active')">{{ $t('filter.active') }} <font-awesome-icon :icon="icons.active" v-if="allowedSortings.active"></font-awesome-icon></th>
                        <th>{{ $t('results.file') }}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody v-if="configurations.length > 0">
                    <tr v-for="(item, index) in configurations" :key="index">
                        <td>{{ item.to_code }}</td>
                        <td>{{ item.name }}</td>
                        <td>{{ formatDate(item.valid_from) }}</td>
                        <td>
                            <font-awesome-icon v-if="item.active" icon="check"></font-awesome-icon>
                        </td>
                        <td><template v-if="item.file"><a :href="item.file" target="_blank"><font-awesome-icon icon="file-download"></font-awesome-icon></a></template></td>
                        <td>
                            <button class="float-right btn btn-sm btn-primary" @click="displayEditForm(index)">
                                <font-awesome-icon   font-awesome-icon icon="edit"></font-awesome-icon>
                            </button>
                        </td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="5">{{ $t('filter.emptyResults') }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="card-footer">
        <div class="float-right">
            <button v-if="firstEnabled" type="button" class="btn-sm btn-primary" @click="firstPageClickHandler">{{ $t('results.firstPage') }}</button>
            <button v-else type="button" class="btn-sm disabled" disabled>{{ $t('results.firstPage') }}</button>
            <button v-if="nextEnabled" type="button" class="btn-sm btn-primary" @click="nextPageClickHandler">{{ $t('results.nextPage') }}</button>
            <button v-else type="button" class="btn-sm disabled" disabled>{{ $t('results.nextPage') }}</button>
        </div>
    </div>
</div>
</template>

<script>
    import moment from 'moment';
    import LoadingIndicator from '@/components/LoadingIndicator.vue'

    export default {
        components: {
            LoadingIndicator
        },
        props: {
            configurations: {
                type: Array,
                default: []
            },
            allowedSortings:  {
                type: Object,
                required: true
            },
            nextEnabled: {
                type: Boolean,
                default: false
            },
            firstEnabled: {
                type: Boolean,
                default: false
            },
            loading: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                resultItems: [1,4],
                activeSort: ['valid_from', 'asc'],
                icons: {
                    'to_code': 'sort',
                    'valid_from': 'sort-up',
                    'active': 'sort'
                }
            };
        },
        methods: {
            setIcons() {
                let keys = Object.keys(this.icons);
                keys.forEach(icon => {
                    let iconName = 'sort';
                    if (icon === this.activeSort[0]) {
                        iconName += (this.activeSort[1] === 'desc' ) ? '-down' : '-up';
                    }
                    this.icons[icon] = iconName;
                });
            },
            sort(field) {
                if (!this.allowedSortings[field]) {
                    return;
                }
                if (field === this.activeSort[0]) {
                    this.activeSort[1] = (this.activeSort[1] === 'asc') ? 'desc' : 'asc';
                } else {
                    this.activeSort = [field, 'asc'];
                }
                this.$emit('sort',  this.activeSort);
                this.setIcons();
            },
            formatDate(data) {
                moment.locale(window.navigator.userLanguage || window.navigator.language);
                if (typeof data === 'string' || data === '') {
                    return moment(data).format('L');
                }
                return(moment(data.seconds * 1000).format('L'));
            },
            showNewElementModal() {
               this.$emit('showNewModal');
            },
            displayEditForm(index) {
                this.$emit('showEditModal', this.configurations[index]);
            },
            nextPageClickHandler() {
                this.$emit('nextPage');
            },
            firstPageClickHandler() {
                this.$emit('firstPage');
            },
            activeIconType(active) {
                if (active) {
                    return "check-square";
                }
                return "square";
            }
        }
    };
</script>

<style scoped lang="scss">
    .filterable {
        cursor: pointer;
    }
    .card-footer {
        button {
            margin-left: 1em;
        }

    }
</style>
